import {Component, HostListener, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from 'src/environments/environment';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-header',
  templateUrl: './ts-header.component.html',
  styleUrls: ['./ts-header.component.scss'],
})
export class V2TsHeaderComponent {
  mobileMenuOpen = false;
  scrolled = false;

  navLinks = [
    {label: 'talentSearchV2.header.talentPool', fragment: 'pool'},
    {label: 'talentSearchV2.header.howItWorks', fragment: 'how'},
    {label: 'talentSearchV2.header.pricing', fragment: 'pricing'},
    {label: 'talentSearchV2.header.customers', fragment: 'testimonials'},
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private bookDemo: BookDemoService,
  ) {}

  openBookDemo(): void {
    this.mobileMenuOpen = false;
    this.bookDemo.open();
  }

  @HostListener('window:scroll')
  onScroll() {
    if (isPlatformBrowser(this.platformId)) {
      this.scrolled = window.scrollY > 20;
    }
  }

  get startNowUrl(): string {
    const subdomain = environment.server === 'dev' ? 'dev' : 'app';
    return `https://${subdomain}.uptal.com/register?type=recruiter-program&feature=talent-search`;
  }

  get loginUrl(): string {
    const subdomain = environment.server === 'dev' ? 'dev' : 'app';
    return `https://${subdomain}.uptal.com/login`;
  }
}
